import { render, staticRenderFns } from "./selector.modal.vue?vue&type=template&id=829cc32c&scoped=true"
import script from "./selector.modal.vue?vue&type=script&lang=js"
export * from "./selector.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829cc32c",
  null
  
)

export default component.exports